<template>
  <div>
    <el-drawer
      show-close
      visible
      :size="600"
      :title="$l('drawer_title_control_product_info') || '控价产品详情'"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="openDialog"
      append-to-body
    >
      <div class="drawer-main">
        <div class="title mb-4">
          {{ $l('title_price_product_info') || '控价产品信息' }}
        </div>
        <el-form
          ref="form"
          size="mini"
          :model="formData"
          :rules="rules"
          :disabled="disabledForm"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_goodsName') || '产品描述'"
                prop="goodsName"
              >
                <el-input
                  v-model="formData.goodsName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="100"
                  clearable
                  size="mini"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mt-2">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_unitLength') || '单品长（CM）'"
                prop="unitLength"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.unitLength"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_unitWidth') || '单品宽（CM）'"
                prop="unitWidth"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.unitWidth"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_unitHeight') || '单品高（CM）'"
                prop="unitHeight"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.unitHeight"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_calUnitCbm') || '单品体积（m³）'"
                prop="unitCbm"
              >
                <el-input size="mini" v-model="calUnitCbm" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_ctnLength') || '外箱长（CM）'"
                prop="ctnLength"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.ctnLength"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_ctnWidth') || '外箱宽（CM）'"
                prop="ctnWidth"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.ctnWidth"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_ctnHeight') || '外箱高（CM）'"
                prop="ctnHeight"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.ctnHeight"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_calCtnCbm') || '外箱体积（m³）'"
                prop="ctnCbm"
              >
                <el-input size="mini" v-model="calCtnCbm" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_unitWeight_g') || '单品重量（g）'"
                prop="unitWeight"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.unitWeight"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_inCtnQty') || '入数'"
                prop="inCtnQty"
              >
                <InputFormat
                  size="mini"
                  :disabled="disabledForm"
                  v-model="formData.inCtnQty"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_ftyPrice') || '工厂价'"
                prop="ftyPrice"
              >
                <InputFormat
                  size="mini"
                  v-model="formData.ftyPrice"
                  :disabled="disabledForm"
                  :precision="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_ftyCurrencyUnit') || '价格单位'"
                prop="ftyCurrencyUnit"
              >
                <dict-select
                  size="mini"
                  v-model="formData.ftyCurrencyUnit"
                  disabled
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'currencyUnit' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button
          type="primary"
          size="small"
          v-if="!disabledForm"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import InputFormat from '../input-format'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { multiply, divide } from '@/libs/util.number.js'
export default {
  components: { InputFormat },
  mixins: [EditLoading],
  props: {
    type: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    amzPriceControlCode: { type: String, default: '' },
    amzPriceControlDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        ftyCurrencyUnit: 'CNY',
      },
      backDialogVisible: false,
      rules: {
        goodsName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        unitLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        unitWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        unitHeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        unitWeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        ctnLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        ctnWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        ctnHeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        ftyPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        inCtnQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      cmToM: 0.000001,
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isView() {
      return this.type == 'view'
    },
    disabledForm() {
      return this.disabled || this.isView
    },
    calCtnCbm() {
      return multiply(
        multiply(
          multiply(this.formData.ctnLength, this.formData.ctnWidth),
          this.formData.ctnHeight
        ),
        this.cmToM
      )
    },
    calUnitCbm() {
      return divide(this.calCtnCbm, this.formData.inCtnQty)
    },
  },
  methods: {
    openDialog() {
      if (!this.disabledForm) {
        this.backDialogVisible = true
        return
      }
      this.close()
    },
    getData() {
      if (!this.amzPriceControlDetailCode) return
      this.$api
        .ecomAmzPriceControlDetailDetailApi({
          amzPriceControlDetailCode: this.amzPriceControlDetailCode,
        })
        .then((res) => {
          this.formData = res.body || {}
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzPriceControlDetailSaveApi({
          ...this.formData,
          amzPriceControlCode: this.amzPriceControlCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
.title {
  height: 23px;
  line-height: 23px;
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}
::v-deep {
  .el-drawer__header {
    font-size: 14px !important;
  }
}
</style>
